import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../store';

export const selectClientsState = createSelector(
  (state: RootState) => state.clients,
  (clients) => clients
);

export const selectClientsData = createSelector(
  selectClientsState,
  (clientStatus) => clientStatus.data?.results
);

export const selectClientsPaginate = createSelector(
  selectClientsState,
  (clientStatus) => clientStatus.data
);
